<template>
  <div v-title data-title="我的分销海报">
    <img v-bind:src="'data:image/png;base64,'+posterbase64" style="width:90%;margin-left:5%;margin-top:5%" />
    <div style="text-align:center;color:black;font-size:16px">长按海报保存到手机或者发送</div>
  </div>
</template>

<script>
import thumb from "../../assets/logo.png";
import { Dialog, Toast } from "we-vue";
export default {
  name: "mydisposter",
  data: function() {
    return {
      logourl: thumb,
      reallogourl: "log",
      title: "",
      description: "",
      orderTotal: "",
      ForwardCount: "",
      Amount: 0,
      userType: -1,
      formset: {},
      posterbase64: "",
      popupVisiblediy: false
    };
  },
  created: function() {
    this.GeneratePoster();
  },
  methods: {
    GeneratePoster: function() {
      this.$store.commit("showLoading");
      var data = {};
      this.$http
        .post(
          this.GLOBAL.BASE_URL + "api/tbproduct/generateinvitationposter",
          data,
          {
            emulateJSON: true
          }
        )
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.posterbase64 = rep.Data;
            this.popupVisiblediy = true;
          } else {
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
        });
    }
  }
};
</script>








// WEBPACK FOOTER //
// src/components/my/mydisposter.vue